import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IUnavailableRequestsReports } from '../data/unavailable-requests-reports';

@Component({
  selector: 'app-list-unavailable-requests-reports',
  templateUrl: './list-unavailable-requests-reports.component.html',
  styleUrls: ['./list-unavailable-requests-reports.component.scss']
})
export class ListUnavailableRequestsReportsComponent {
  @Input() unavailableRequestsReports: IUnavailableRequestsReports[] = [];
  @Output() mudouTamanhoPagina = new EventEmitter<number>();
  @Output() mudouPagina = new EventEmitter<number>();
  @Output() recarregarListagem = new EventEmitter<void>();
  @Input() dadosPaginacao: {
    paginaSelecionada: number;
    tamanhoPagina: number;
    totalPaginas: number;
    itensTotal: number;
  } = {
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };
}
